<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          dark
          class="mb-4"
          @click="redirectTo()"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="dataItem.image_url"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="onImageError($event, dataItem, 'image_url')"
          />
        </div>
      </v-col>
    </v-row>

    <v-row
      no-gutters
      class="mt-3"
      style="margin-bottom: 160px; background: #ffffff; border-radius: 4px"
    >
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ dataItem.name }}
            </p>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" class="text-start pa-0 d-flex justify-start">
            <v-spacer></v-spacer>
            <v-chip
              class="mt-2 mb-4 text-center"
              :color="site.color"
              small
              outlined
              @click="handleClickGamificationHistory"
            >
              {{ $t("history") }} <v-icon small> mdi-chevron-right </v-icon>
            </v-chip>
          </v-col>

          <v-col cols="12" class="text-start pa-0 d-flex justify-start">
            <v-row no-gutters>
              <v-col
                v-if="showEndDate"
                cols="12"
                class="text-start pa-0 d-flex justify-start align-center mb-4"
              >
                <div class="ml-4" style="width: 48px; min-width: 48px">
                  <v-icon :color="site.color">mdi-calendar-clock</v-icon>
                </div>
                <div>
                  <div style="font-size: 10px">
                    {{ $t("expireDate") }}
                  </div>
                  <div style="font-size: 14px; color: #00000099">
                    {{ dataItem.end_date | formatDate }}
                  </div>
                </div>
              </v-col>
              <v-col
                v-if="!checkConditionEntryPassFree(dataItem)"
                cols="12"
                class="text-start pa-0 d-flex justify-start align-center mb-4"
              >
                <div class="ml-4" style="width: 48px; min-width: 48px">
                  <div v-if="dataItem.input_type == 'point'">
                    <PointSymbol
                      v-if="
                        Array.isArray(dataItem.point) &&
                        dataItem.point.length > 0
                      "
                      :type="dataItem.point[0].point_type_type"
                      :symbol="dataItem.point[0].point_type_symbol"
                      :color="dataItem.point[0].point_type_color"
                      :is_display="true"
                      :outlined_box="false"
                      :size="28"
                    />
                  </div>
                  <v-icon v-else :color="site.color"
                    >mdi-ticket-confirmation-outline</v-icon
                  >
                </div>
                <div>
                  <div style="font-size: 14px; color: #00000099">
                    {{ getConditionEntryPass(dataItem) }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12">
                <v-card elevation="0">
                  <p class="text-subtitle-2 mb-0 ml-4 font-weight-bold">
                    {{ $t("detail") }}
                  </p>
                  <div
                    class="ml-4 ql-editor"
                    style="height: fit-content"
                    v-html="formatHtmlDetail(dataItem.description)"
                  ></div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col v-if="checkCanPlay" cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="confirmGamification()"
                  :disabled="checkLimitReached"
                >
                  {{
                    checkLimitReachedRepeatPerDay
                      ? $t("limitReachedPerDay")
                      : checkLimitReached
                      ? $t("limitReached")
                      : $t("letsJoin")
                  }}
                </v-btn>
              </v-col>
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  outlined
                  @click="redirectTo()"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import moment from "moment";
import PointSymbol from "../../../components/point/point-symbol.vue";
import { formatHtmlDetailDefault } from "../../../config/general-function.js";

export default {
  inject: ["isAppLoading"],
  components: { PointSymbol },
  data: () => ({
    dataItem: {},
    redirect_name: null,
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
      // ========== ========== ========== ==========
      if (!vm.previousRouteName) {
        vm.redirect_name = "gamification-all";
      } else if (vm.previousRouteName != "gamification-all") {
        vm.redirect_name = "main";
      }
    });
  },
  async created() {
    this.isAppLoading(true);
    await this.getGamificationDetail();
    this.isAppLoading(false);
  },
  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    redirectTo() {
      this.$router.push({
        name: this.redirect_name,
      });
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    async getGamificationDetail() {
      try {
        const response = await Axios.get(
          "gamification/getGamificationDetail/" + this.$route.params.id
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataItem = data;
        }
      } catch (err) {
        console.log("err :>> ", err);
        this.$router.push({
          name: "gamification-all",
        });
      }
    },
    confirmGamification() {
      this.$router.push({
        name: "gamification",
        params: { id: this.$route.params.id },
      });
    },
    handleClickGamificationHistory() {
      this.$router.push({
        name: "gamification-history",
        params: { id: this.$route.params.id },
      });
    },

    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    getConditionEntryPass(param) {
      let text = `-`;
      const input_type = param.input_type;
      const point = param.point;
      const reward_name = param.reward_name;
      if (input_type == "point") {
        if (Array.isArray(point) && point.length > 0 && point[0].point) {
          text = `${this.commaPoint(point[0].point)} ${
            point[0].point_type_name
          }`;
        }
      } else if (input_type == "reward" && reward_name) {
        text = `${reward_name}`;
      }
      return text;
    },
    checkConditionEntryPassFree(param) {
      let isFree = false;
      const input_type = param.input_type;
      const point = param.point;
      if (input_type == "point") {
        if (
          !point ||
          (Array.isArray(point) && point.length > 0 && !point[0].point)
        ) {
          isFree = true;
        }
      }
      return isFree;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["color", "site", "customer"]),
    showEndDate() {
      let check = true;
      if (this.dataItem) {
        const end_date = moment(this.dataItem.end_date);
        const diff = moment().diff(end_date, "year");
        if (Math.abs(diff) > 5) {
          check = false;
        }
      }
      return check;
    },
    checkCanPlay() {
      let check = true;
      if (
        this.site.account_type == "group_account" &&
        this.customer.parent_employee_id
      ) {
        check = false;
      }
      return check;
    },
    checkLimitReached() {
      let check = false;
      const funcCheckHaveListComponent = (item) => {
        let _check = true;
        if (
          !Array.isArray(item?.list_component) ||
          (Array.isArray(item?.list_component) &&
            item?.list_component.length == 0)
        ) {
          _check = false;
        }
        return _check;
      };
      const checkHaveListComponent = funcCheckHaveListComponent(this.dataItem);
      let gameSetting = null;
      if (checkHaveListComponent) {
        gameSetting = this.dataItem?.list_component[0].gameSetting;
      }
      if (
        (!checkHaveListComponent ||
          !this.dataItem?.canvas_setting ||
          gameSetting?.listItem.length == 0) &&
        this.dataItem?.source == "internal"
      ) {
        check = true;
      } else if (this.dataItem?.source == "external") {
        if (
          this.dataItem?.partner_code == "GAMEMICK" &&
          (!this.dataItem?.external_data?.game_uuid ||
            this.dataItem?.limit_reached)
        ) {
          check = true;
        }
      }
      return check;
    },
    checkLimitReachedRepeatPerDay() {
      let check = false;
      if (this.dataItem?.limit_reached_repeat_per_day) {
        check = true;
      }
      return check;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY, HH:mm");
    },
  },
};
</script>

<style scoped>
.spaceBottom {
  margin-bottom: 25%;
}
.item-detail > h1 {
  line-height: 2rem;
}
img {
  width: 100% !important;
}
</style>
